import React, { memo, useCallback, useRef, useState } from 'react';
import { Marker } from 'react-map-gl';

import { useMapPopupPosition } from '@/hooks/useMapPopupPosition';
import { IGeocodeFeature } from '@/services/types/mapbox/mapboxApi';

import MapPopup, { EMapPopupType } from '../MapPopup/MapPopup';
import MapMarker, { MapMarkerTypes } from '../SearchMapMarker/MapMarker';

type TProps = {
  id: number;
  lat?: number | undefined;
  lon?: number | undefined;
  onClick?: (id: number) => void;
  isPopupVisible: boolean;
  container: Element | null;
  place?: IGeocodeFeature | null;
  isRetrieved?: boolean;
};

const SearchMapAddressMarker: React.FC<TProps> = ({
  id,
  lat,
  lon,
  onClick,
  isPopupVisible,
  container,
  place,
  isRetrieved,
}) => {
  const markerRef = useRef<HTMLDivElement>(null);

  // We use `useState` here because we want to force a rerender when we get the popup ref
  const [popupRef, setPopupRef] = useState<HTMLDivElement | null>(null);
  const popupStyle = useMapPopupPosition({
    container,
    anchor: markerRef.current,
    popup: popupRef,
    isVisible: isPopupVisible,
  });

  const handleOnClick = useCallback<(e: React.MouseEvent<HTMLButtonElement>) => void>(
    e => {
      e.stopPropagation();
      onClick?.(id);
    },
    [id, onClick],
  );

  const handleOnMouseEnter = () => {};

  const handleOnMouseLeave = () => {};

  if (!lat || !lon) {
    return null;
  }

  return (
    <Marker style={{ zIndex: isPopupVisible ? 10 : 1 }} latitude={lat} longitude={lon}>
      <div className="relative" ref={markerRef}>
        {isPopupVisible && (
          <MapPopup
            ref={setPopupRef}
            style={popupStyle}
            currency="USD"
            listings={[]}
            onWheelCapture={() => {}}
            onTouchStart={() => {}}
            onTouchEnd={() => {}}
            isOnWishlist={false}
            variant={EMapPopupType.ADDRESS}
            place={place}
            isRetrieved={isRetrieved}
          />
        )}
        <MapMarker
          type={MapMarkerTypes.ADDRESS}
          onClick={handleOnClick}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      </div>
    </Marker>
  );
};

export default memo(SearchMapAddressMarker);
